<template>
  <div class="d-flex justify-start align-center" style="width: 100%">
    <ConfirmRoomsDialog
      :state="confirmStudentDialog"
      :importedDocuments="importedDocuments"
      @closeDialog="closeConfirmDialog"
      @updateResult="onUpdateResultDocument"
      ref="roomsDialog"
    />
    <InvalidSubjectDialog :state="invalidDialog" :invalidRooms="invalidSubjects" @closeDialog="closeInvalid" />
    <NotEmptyRooms :state="nonEmptyDialog" @closeDialog="closeEmpty" />
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mt-0 ml-6" color="green" dark v-bind="attrs" v-on="on" outlined>
          Nhập/xuất Excel phòng thi
        </v-btn>
      </template>

      <v-list>
        <v-list-item class="cursor-pointer">
          <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa thông tin phòng thi</v-list-item-title>
          <input
            ref="uploader"
            type="file"
            class="d-none"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onFileChanged"
          />
        </v-list-item>
        <v-list-item class="cursor-pointer">
          <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel mẫu</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
import * as XLSX from 'xlsx'
import { Room } from '@/plugins/api'
import ConfirmRoomsDialog from './ConfirmRoomsDialog.vue'
import NotEmptyRooms from './NotEmptyRooms.vue'
import InvalidSubjectDialog from './InvalidSubjectDialog.vue'

const schema = {
  STT: {
    prop: 'index',
    type: Number
  },
  'Tên phòng thi': {
    prop: 'name',
    type: String
  },
  'Mã phòng thi': {
    prop: 'code',
    type: String
  },
  Buổi: {
    prop: 'note',
    type: String
  },
  'Số lượng': {
    prop: 'capacity',
    type: Number
  },
  'Địa điểm': {
    prop: 'location',
    type: String
  },
  Môn: {
    prop: 'subjects',
    type: String
  }
}
/* eslint-disable no-unused-vars */

export default {
  components: { ConfirmRoomsDialog, InvalidSubjectDialog, NotEmptyRooms },
  data() {
    return {
      dialog: false,
      rooms: null,
      confirmStudentDialog: false,
      isSelecting: false,
      invalidDialog: false,
      nonEmptyDialog: false,
      invalidSubjects: '',
      importedDocuments: [],
      exam: this.$route.params.id,
      json_fields: {
        STT: 'index',
        'Tên phòng thi': 'name',
        'Mã phòng thi': 'code',
        Buổi: 'note',
        'Số lượng': 'capacity',
        'Địa điểm': 'location',
        Môn: {
          field: 'subjects',
          callback: subjects => subjects.map(subject => subject.name).join(', ')
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAuthenticated'])
  },
  methods: {
    ...mapActions('room', ['fetchRooms']),
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },

    async getStudentExcel() {
      this.$loading.active = true
      const rooms = await this.fetchRooms({ exam: this.exam, _limit: -1 })
      this.rooms = rooms
      this.$loading.active = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmStudentDialog = true
      }
      this.$loading.active = false
    },
    formatDataForExport(data) {
      return data.map(item => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldInfo = this.json_fields[key]
          let value = item

          if (typeof fieldInfo === 'string') {
            const pathParts = fieldInfo.split('.')
            pathParts.forEach(part => {
              if (value) {
                value = value[part]
              }
            })
          } else if (typeof fieldInfo === 'object') {
            value = item[fieldInfo.field]
            if (fieldInfo.callback) {
              value = fieldInfo.callback(value)
            }
          }

          formattedItem[key] = value || ''
        }
        return formattedItem
      })
    },

    async exportDataToExcel() {
      await this.getStudentExcel()
      const formattedData = this.formatDataForExport(this.rooms)

      const dataForSheet =
        formattedData.length > 0 ? formattedData : this.getHeaders().map(header => ({ [header]: '' }))

      const worksheet = XLSX.utils.json_to_sheet(dataForSheet, { header: this.getHeaders(), skipHeader: false })

      this.setColumnWidths(worksheet, dataForSheet)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Rooms')

      XLSX.writeFile(workbook, 'xep-phong-thi-mau.xlsx')
      this.$loading.active = false
    },

    getHeaders() {
      const headers = []
      for (let key in this.json_fields) {
        headers.push(key)
      }
      return headers
    },

    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const fileData = {
        exam: this.exam,
        room: data
      }
      const assigned = await Room.excelRooms(fileData)
      if (assigned.notEmpty) {
        this.$refs.roomsDialog.stopLoading()
        this.nonEmptyDialog = true
      } else if (!assigned.missingSubjects) {
        this.closeConfirmDialog()
        this.$emit('refresh')
      } else {
        this.$refs.roomsDialog.stopLoading()
        this.invalidSubjects = assigned.missingSubjects
        this.invalidDialog = true
      }
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidRooms = ''
    },
    closeEmpty() {
      this.nonEmptyDialog = false
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })
      worksheet['!cols'] = maxWidths.map(width => ({ width }))
    },
    closeConfirmDialog() {
      this.isSelecting = false
      this.confirmStudentDialog = false
      this.$refs.uploader.value = null
    }
  }
}
</script>
